export enum CalculateRouteErrorCode {
  API_CALCULATION_ERROR = 'FAILED_TO_CALCULATE_TRANSPORT_EMISSIONS_ECOTRANSIT_API',
}
